import instance from './instance'
import houseModule from './house'

export default{
    house: houseModule(instance),
}